import { Box } from "@mantine/core";
import {
  clearNotifications,
  setWipFilter,
  batchUpdateWipAssetSuccess,
  selectStyles,
  getStylesSuccess,
} from "modules/Distributions/distributionSlice";
import { connect, useDispatch } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import { useEffect } from "react";

import { logger } from "utils/logger";

import Style from "./features/style/Style";
import Distributions from "./features/distributions/Distributions";
import { ERROR_TYPES } from "utils/constants";
import ItemNotFound from "core/components/itemNotFound/ItemNotFound";

const DistributionModule = ({
  user,
  guide,
  guides,
  selectedSamples,
  success,
  error,
  setSampleFilter,
  guideFilter,
  selectSamples,
  setGuideFilter,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // SUCCESS AND ERROR HANDLERS
  useEffect(() => {
    logger.log(success, error);
    if (error) {
      
      dispatch(clearNotifications());
      
      if(error.type && error.type === ERROR_TYPES.NOT_FOUND){
        navigate('/distributions/item-not-found')
      }else{
        showNotification({
          title: "Whoops something went wrong.",
          message: error.message,
          position: "top-center",
          color: "red",
        });       
      }
    }

    if (success) {
      switch (success.type) {
        case batchUpdateWipAssetSuccess.toString(): {
          showNotification({
            title: "Success",
            message: success.message,
            position: "top-center",
            color: "teal",
          });

          dispatch(clearNotifications());

          break;
        }
        case getStylesSuccess.toString(): {
          dispatch(clearNotifications());
          break;
        }
        default: {
          break;
        }
      }
    }

    // if the session has been created then we load the session detail view
  }, [error, success, dispatch, clearNotifications]);

  const location = useLocation();

  useEffect(() => {
    // Attempt to restore scroll position when route changes
    const scrollPosition = sessionStorage.getItem(location.pathname);

    if (scrollPosition) {
      window.scrollTo(0, parseInt(scrollPosition, 10));
    } else {
      window.scrollTo(0, 0);
    }

    // Save scroll position before navigating away
    const handleScroll = () => {
      sessionStorage.setItem(location.pathname, window.scrollY.toString());
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname]);

  return (
    <Box
      id="wipModule"
      className="module-container"
      // style={(theme) => ({
      //     backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
      //     width: '100%',
      //     height: '100%',
      // })}
    >
      <Routes>
        <Route path="/" element={<Distributions />}></Route>
        <Route path="/:id" element={<Style />}></Route>
        <Route path="/item-not-found" element={<ItemNotFound ctaLabel="Return to Distributions" ctaCallback={() => navigate('/distributions') } />}></Route>
      </Routes>
    </Box>
  );
};

const mapStateToProps = (state, props) => {
  //logger.log(state,props, ' mapstate')
  return {
    user: state.auth.user,
    wipFilter: state.distributionReducer.wipFilter,
    selectedStyles: state.distributionReducer.selectedStyles,
    wip: state.distributionReducer.selectedWip,
    // guides: state.guideReducer.guides,
    success: state.distributionReducer.success,
    displayPrefs: state.distributionReducer.displayPrefs,
    error: state.distributionReducer.error,
  };
};

const mapDispatchToProps = { setWipFilter, selectStyles };

export default connect(mapStateToProps, mapDispatchToProps)(DistributionModule);
